import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast from 'react-hot-toast';

export const getAllActiveBusesForLane = async (laneId) => {
    const token = await UserProfile.getToken();
    const formData = new FormData();
    formData.append("terminal", laneId);
    const response = await axios.post(`${apiUrl}admin/get_buses`, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response
}

export const getActiveBusesNameList = async (laneId) => {
    const token = await UserProfile.getToken();
    const formData = new FormData();
    formData.append("terminal", laneId);
    const response = await axios.post(`${apiUrl}admin/active-buses`, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response
}

// Create an axios instance with a base URL and authentication header
const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Get token from localStorage or another source
    }
});

// Define the busesAPI with basic CRUD operations and custom actions
export const busesAPI = {
    // Basic GET operation to fetch all buses
    getAll: () => api.get('buses/'),

    filter: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get(`buses/?${params}`);
    },

    patch: (id, data) => api.patch(`buses/${id}/`, data),
    
    // GET operation to fetch a single bus by ID
    getById: (id) => api.get(`buses/${id}/`),
    
    getOutgoingBusOrders: (busId, filters = {}) => {
        const params = new URLSearchParams(filters).toString();
        return api.get(`buses/${busId}/get-bus-outgoing-orders/?${params}`);
    },
    
    load: async (id) => {
        try {
            const response = await api.put(`buses/${id}/load/`);
            toast.success(response.data?.msg || 'Bus loaded successfully!');  // Show success message from response
            return response.data;
        } catch (error) {
            toast.error(`${error.response?.data?.msg || error.message}`);
            // throw error;
        }
    },

    // Custom action: Unload bus
    unload: async (id, terminal) => {
        try {
            const response = await api.put(`buses/${id}/unload/`, { terminal });
            toast.success(response.data?.msg || 'Bus unloaded successfully!');  // Show success message from response
            return response.data;
        } catch (error) {
            toast.error(`${error.response?.data?.msg || error.message}`);
            // throw error;
        }
    },

    getStops: async (id) => {
        try {
            const response = await api.get(`buses/${id}/get-stops/`);
            return response.data;
        } catch (error) {
            toast.error(`${error.response?.data?.msg || error.message}`);
        }
    },

    getUpdates: async (id, searchText) => {
        try {
            const response = await api.get(`buses/${id}/get-updates/`, {
                params: { search: searchText }
            });
            return response.data;
        } catch (error) {
            toast.error(`${error.response?.data?.msg || error.message}`);
        }
    },
};

// Add request interceptor to dynamically include the token before each request
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken();  // Ensure the UserProfile method is implemented to get the token
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Dynamically add the token to the Authorization header
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});